import moment from 'moment';

const testingEventsMixin = {
    data() {
        return {
            items: [],
            notDispatchedCount: 0,
            retakesCount: 0,
        }
    },
    computed: {
        structureDuration() {
            if (this.app.testingStructure)
                return parseInt(this.app.testingStructure.duration) + 5;

            return 90;
        },


    },
    methods: {

        eventTiming() {
            this.eventForm.officeId = this.app.nrkOffice ? this.app.nrkOffice.id : '';

            this.eventForm.startTime = this.app.nrkDate ? this.app.nrkDate : this.$moment().add(7, 'days').hours(9).minutes(5).format(this.app.type.id !== this.APP_TYPE_DEMO ? 'YYYY-MM-DD HH:mm':'YYYY-MM-DD');

            if (this.app.type.id !== this.APP_TYPE_DEMO)
                this.eventForm.endTime = this.app.nrkDate ? this.$moment(this.app.nrkDate, 'YYYY-MM-DD HH:mm').add(this.structureDuration, 'minutes').format('YYYY-MM-DD HH:mm')
                    : this.$moment(this.eventForm.startTime, 'YYYY-MM-DD HH:mm').add(this.structureDuration, 'minutes').format('YYYY-MM-DD HH:mm');
            else
                this.eventForm.endTime = this.app.nrkDate ? this.$moment(this.app.nrkDate, 'YYYY-MM-DD').add(10, 'days').format('YYYY-MM-DD')
                    : this.$moment(this.eventForm.startTime, 'YYYY-MM-DD').add(10, 'days').format('YYYY-MM-DD');
        },

        fetchCalendarEvents(appId, params = null, subject = 'app',) {
            if (params) {
                params = this.cleanObject(params);
                params.calendar = 1;
            }

            return this.axios.get(this.$config.urls.event.fetchEvents.url, {params: params})
                .then(response => {

                    if (subject === 'app')
                        this.items = this.getAppEventsForCalendar(response.data.data.items, appId);
                    else if (subject === 'all')
                        this.items = this.fetchAllEventsForCalendar(response.data.data.items);

                }).catch(() => {
                });
        },

        fetchOfficeEvents(officeId, forCalendar = false, params = null) {

            if (params)
                params = this.cleanObject(params);

            return this.axios.get(this.$config.urls.office.fetchOfficeEVents.url.replace(':id', officeId), {params: params}).then(response => {

                if (forCalendar)
                    this.items = this.getOfficeEventsForCalendar(response.data.data, officeId);
                else
                    this.items = response.data.data;

            }).catch(() => {
            });
        },

        fetchAppEvents(appId, forCalendar = false, params = null) {

            if (params)
                params = this.cleanObject(params);

            return this.axios.get(this.$config.urls.application.fetchTestingEvents.url.replace(':id', appId), {params: params})
                .then(response => {

                    if (forCalendar)
                        this.items = this.getAppEventsForCalendar(response.data.data.testingEvents, appId);
                    else
                        this.items = response.data.data.testingEvents;

                    this.notDispatchedCount = response.data.data.notDispatchedCandidateCount;
                    this.retakesCount = response.data.data.retakesCount;

                }).catch(() => {
                });
        },

        fetchAllEventsForCalendar(items) {
            return items.map(item => {

                if (item.application.resource.type.id === this.RESOURCE_NRK_ID)
                    item.title = item.application.resource.resourceTitle;
                else
                    item.title = item.application.resource.title;

                item.start = this.$moment(item.startTime, 'YYYY-MM-DD HH:mm').format();
                item.end = this.$moment(item.endTime, 'YYYY-MM-DD HH:mm').format();
                item.allDay = false;
                item.textColor = '#fff';
                item.eventId = item.id;

                if (item.isActive)
                    item.color = '#2BB784';
                else if (item.eventStatus === 'EVENT_FAILED')
                    item.color = '#FFB119';
                else
                    item.color = item.isPassed ? '#EC3765' : '#288BE4';

                return item;

            });
        },

        saveAppEvent(appId, eventId = null) {
            let params = {};
            if (eventId)
                params.id = eventId;

            return this.axios.post(this.$config.urls.application.createEvent.url.replace(':id', appId), this.eventForm, {params: params})
                .then(() => {
                    this.snotifySuccess('saveSuccessMsg');
                    this.eventForm = {};
                }).catch(() => {
                });
        },

        getAppEventsForCalendar(items, appId) {
            return items.map(item => {
                if (item.application.resource.type.id === this.RESOURCE_NRK_ID)
                    item.title = item.application.resource.resourceTitle;
                else
                    item.title = item.application.resource.title;

                item.start = this.$moment(item.startTime, 'YYYY-MM-DD HH:mm').format();
                item.end = this.$moment(item.endTime, 'YYYY-MM-DD HH:mm').format();
                item.allDay = false;
                item.textColor = '#fff';
                item.eventId = item.id;

                if (parseInt(appId) === item.application.id) {

                    if (item.isActive)
                        item.color = '#2BB784';
                    else if (item.eventStatus === 'EVENT_FAILED')
                        item.color = '#FFB119';
                    else
                        item.color = item.isPassed ? '#EC3765' : '#288BE4';


                } else {
                    item.editable = false;

                    if (item.isActive)
                        item.color = '#7DCCAF';
                    else if (item.eventStatus === 'EVENT_FAILED') {
                        item.color = '#ffeb88';
                        item.textColor = '#A5A5A5';
                    } else
                        item.color = item.isPassed ? '#C8C8C8' : '#93B1E5';
                }

                return item;
            });
        },

        getOfficeEventsForCalendar(items, officeId) {

            if (items.length > 0) {
                let item = items[0];
                this.businessHours.startTime = moment(item.office.startTime, 'HH:mm:ss').format('HH:mm');
                this.businessHours.endTime = moment(item.office.endTime, 'HH:mm:ss').format('HH:mm');
            }

            return items.map(item => {

                if (item.application.resource.type.id === this.RESOURCE_NRK_ID)
                    item.title = item.application.resource.resourceTitle;
                else
                    item.title = item.application.resource.title;

                item.start = this.$moment(item.startTime, 'YYYY-MM-DD HH:mm').format();
                item.end = this.$moment(item.endTime, 'YYYY-MM-DD HH:mm').format();
                item.textColor = '#fff';
                item.allDay = false;
                item.eventId = item.id;

                if (this.$route.name.includes('application.profile')) {

                    if (parseInt(this.$route.params.id) === item.application.id) {

                        if (item.isActive)
                            item.color = '#2BB784';
                        else if (item.eventStatus === 'EVENT_FAILED')
                            item.color = '#FFB119';
                        else
                            item.color = item.isPassed ? '#EC3765' : '#288BE4';
                    } else {

                        item.editable = false;

                        if (item.isActive)
                            item.color = '#7DCCAF';
                        else if (item.eventStatus === 'EVENT_FAILED') {
                            item.color = '#ffeb88';
                            item.textColor = '#A5A5A5';
                        } else
                            item.color = item.isPassed ? '#C8C8C8' : '#93B1E5';
                    }
                } else {

                    if (parseInt(officeId) === item.office.id) {

                        if (item.isActive)
                            item.color = '#2BB784';
                        else if (item.eventStatus === 'EVENT_FAILED')
                            item.color = '#FFB119';
                        else
                            item.color = item.isPassed ? '#EC3765' : '#288BE4';
                    } else {
                        item.editable = false;

                        if (item.isActive)
                            item.color = '#7DCCAF';
                        else if (item.eventStatus === 'EVENT_FAILED') {
                            item.color = '#ffeb88';
                            item.textColor = '#A5A5A5';
                        } else
                            item.color = item.isPassed ? '#C8C8C8' : '#93B1E5';
                    }
                }

                return item;
            });
        }
    }
};
export default testingEventsMixin;
